module.exports = __webpack_public_path__ + "img/9000.93761c21.jpg";